<template>
<v-list-group>
  <template slot="activator">
    <v-list-tile>
      <v-list-tile-avatar>
        <h-icon>{{icon}}</h-icon>
      </v-list-tile-avatar>
      <v-list-tile-title>{{title}}</v-list-tile-title>
    </v-list-tile>
  </template>
  <slot></slot>
</v-list-group>
</template>

<script>
export default {
  props: ["title", "icon"]
}
</script>
